import React from 'react';

const LicencesIcon = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 26"
    fill="none"
    {...props}
  >
    <path
      d="M7.29268 14.3883L9.99935 12.335L12.6944 14.3883L11.6677 11.0633L14.3743 8.91667H11.061L9.99935 5.63833L8.93768 8.91667H5.62435L8.31935 11.0633L7.29268 14.3883ZM19.3327 10.0833C19.3327 4.92667 15.156 0.75 9.99935 0.75C4.84268 0.75 0.666016 4.92667 0.666016 10.0833C0.666016 12.4517 1.55268 14.5983 2.99935 16.2433V25.25L9.99935 22.9167L16.9993 25.25V16.2433C18.446 14.5983 19.3327 12.4517 19.3327 10.0833ZM9.99935 3.08333C13.861 3.08333 16.9993 6.22167 16.9993 10.0833C16.9993 13.945 13.861 17.0833 9.99935 17.0833C6.13768 17.0833 2.99935 13.945 2.99935 10.0833C2.99935 6.22167 6.13768 3.08333 9.99935 3.08333ZM9.99935 20.5833L5.33268 21.7733V18.1567C6.70935 18.95 8.29602 19.4167 9.99935 19.4167C11.7027 19.4167 13.2893 18.95 14.666 18.1567V21.7733L9.99935 20.5833Z"
      fill={fill}
    />
  </svg>
);

export default LicencesIcon;
